import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import { MenuItem } from '@bingads-webui-react/primitive';
import { StyledBaMenuItem } from './menu-item';

const getBorderClassName = (classes, index, responsiveSize) => {
  if (responsiveSize !== 'xxl') {
    return classes.topBorder;
  } else if (index !== 0) {
    return classes.leftBorder;
  }

  return '';
};

const getTopPaddingClassName = (classes, responsiveSize) => {
  if (responsiveSize === 'xxl') {
    return classes.topPadding;
  }
  return '';
};

const getSubmenuCalloutPlacement = (menuData, responsiveSize, index) => {
  if (responsiveSize === 'l'
    || index === menuData.length - 1) {
    return 'left';
  }

  return 'right';
};

export const renderMenu = ({
  classes,
  menuData,
  responsiveSize,
  i18n,
  calloutPlacement,
  closeDropdown,
  siteMap,
  topLevel,
  headerId,
}) => {
  const singleLevelMenuCalloutPlacement = 'left';

  let iterativeData;

  if (_.isArray(menuData)) {
    iterativeData = menuData;
  } else if (_.isFunction(menuData)) {
    iterativeData = menuData().children;
  } else {
    iterativeData = menuData.children;
  }

  if (_.isUndefined(iterativeData)) {
    return null;
  }

  return (
    iterativeData.map((item, index) => {
      if (!item.children) {
        return null;
      }

      if (item.children.length !== 0 && topLevel < 1) {
        return (
          <div
            className={classNames(
              getBorderClassName(classes, index, responsiveSize),
              getTopPaddingClassName(classes, responsiveSize)
            )}
            key={item.id}
          >
            <MenuItem
              id={item.id}
              header
            >
              {i18n.getString(item.name)}
            </MenuItem>

            {renderMenu({
              classes,
              menuData: item.children,
              responsiveSize,
              i18n,
              calloutPlacement: getSubmenuCalloutPlacement(iterativeData, responsiveSize, index),
              closeDropdown,
              siteMap,
              topLevel: topLevel + 1,
              headerId: item.id,
            })}
          </div>
        );
      } else if (item.children.length === 0 || topLevel === 1) {
        if (item.name === 'Divider') {
          return (
            <MenuItem
              key={item.id}
              divider
            />
          );
        }
        return (
          <StyledBaMenuItem
            className={classNames([classes.menuItem, classes.toggleable])}
            customizedClass={item.className}
            customizedOnClick={item.onClick}
            key={item.id}
            menuItemKey={item.id}
            siteMap={siteMap}
            siteMapId={item.id}
            externalLink={item.externalLink}
            calloutPlacement={calloutPlacement || singleLevelMenuCalloutPlacement}
            closeDropdown={closeDropdown}
            showTag={item.showTag}
            tagClass={item.tagClass}
            i18n={i18n}
            headerId={headerId}
          >
            {i18n.getString(item.name)}
          </StyledBaMenuItem>
        );
      }
      return null;
    })
  );
};
